import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from './keys';
import type { SettingsSection } from '../types';

export function useSettings({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.settings,
    queryFn: () => api<{ sections: SettingsSection[] }>('/api/settings'),
    enabled,
  });
}

export function useSaveSettings() {
  const client = useQueryClient();
  return useMutation({
    meta: { success: 'Settings saved' },
    mutationFn: (values: Record<string, unknown>) =>
      api<{ sections: SettingsSection[] }>('/api/settings', 'PUT', { values }),
    onSuccess: (data) => {
      client.setQueryData(queryKeys.settings, data);
    },
  });
}
